function processTableContent(table: string): string {
	return table
		.split("\n")
		.map((l) => l.trim())
		.filter(Boolean)
		.join("\n")
		.replace(/(<[^>]*>)|\*\*(.*?)\*\*/gm, (_m, tag, bold) =>
			// eslint-disable-next-line @typescript-eslint/no-unsafe-return
			tag === undefined ? `<b>${bold}</b>` : tag,
		);
}

/**
 * Preprocesses HTML table blocks in markdown content.
 *
 * The naive approach of using a non-greedy regex to match <table>...</table> breaks
 * when tables are nested: the regex stops at the first </table> (the inner table's close),
 * leaving the outer table's remaining rows unprocessed. Those rows still contain blank
 * lines which cause CommonMark to terminate the HTML block early — subsequent indented
 * content is then interpreted as an indented code block, leaking raw HTML as visible text.
 *
 * This function correctly handles nesting by counting <table>/<\/table> tag depth.
 */
function preprocessHtmlTag(content: string, tagName: string): string {
	let result = "";
	let src = content;
	const openRegex = new RegExp(`<${tagName}[^>]*>`, "i");

	while (src.length > 0) {
		const openMatch = openRegex.exec(src);

		if (!openMatch) {
			result += src;
			break;
		}

		result += src.slice(0, openMatch.index);
		src = src.slice(openMatch.index);

		let depth = 0;
		let blockEnd = src.length;

		const tagRegex = new RegExp(`<\\/?${tagName}[^>]*>`, "gi");
		let tagMatch;

		// looping over regex matches to find the table's ending tag (with correct depth)
		while ((tagMatch = tagRegex.exec(src)) !== null) {
			depth += tagMatch[0].startsWith("</") ? -1 : 1;
			if (depth === 0) {
				blockEnd = tagMatch.index + tagMatch[0].length;
				break;
			}
		}

		result += processTableContent(src.slice(0, blockEnd));
		src = src.slice(blockEnd);
	}

	return result;
}

export function preprocessHtmlBlocks(content: string): string {
	let result = content;

	result = preprocessHtmlTag(result, "table");
	result = preprocessHtmlTag(result, "div");

	return result;
}
